import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { initializeRemoteFlagsListenerSaga } from './fetch-remote-flags';

export function* rootSaga(): SagaIterator {
    yield all([fork(initializeRemoteFlagsListenerSaga)]);
}
